import createIcon from '../../createIcon';

/**
 * @component @name NightsStay
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuNDIwMyAxMi4wN0MxMC4wOTAzIDcuNTYgMTEuOTIwMyAzLjU5IDEyLjk1MDMgMkM3LjU5MDMxIDIuMTkgMy4zMDAzMSA2LjU4IDMuMzAwMzEgMTEuOTlDMy4zMDAzMSAxMi4xMyAzLjMyMDMxIDEyLjI3IDMuMzIwMzEgMTIuNDFDMy45NDAzMSAxMi4xNCA0LjYxMDMxIDExLjk5IDUuMzIwMzEgMTEuOTlDNi45ODAzMSAxMS45OSA4LjUwMDMxIDEyLjgyIDkuNDIwMzEgMTQuMTRDMTEuMDkwMyAxNC42MiAxMi4zMjAzIDE2LjE2IDEyLjMyMDMgMTcuOTlDMTIuMzIwMyAxOS41MSAxMS40NTAzIDIwLjgyIDEwLjIwMDMgMjEuNUMxMS4xODAzIDIxLjgyIDEyLjIzMDMgMjIgMTMuMzEwMyAyMkMxNi44MTAzIDIyIDE5Ljg5MDMgMjAuMiAyMS42ODAzIDE3LjQ4QzE5LjMyMDMgMTcuNzEgMTQuNzAwMyAxNi41MSAxMi40MjAzIDEyLjA3WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTguMzIwMzEgMTUuOTlIOC4xNDAzMUM3LjcyMDMxIDE0LjgzIDYuNjIwMzEgMTMuOTkgNS4zMjAzMSAxMy45OUMzLjY2MDMxIDEzLjk5IDIuMzIwMzEgMTUuMzMgMi4zMjAzMSAxNi45OUMyLjMyMDMxIDE4LjY1IDMuNjYwMzEgMTkuOTkgNS4zMjAzMSAxOS45OUg4LjMyMDMxQzkuNDIwMzEgMTkuOTkgMTAuMzIwMyAxOS4wOSAxMC4zMjAzIDE3Ljk5QzEwLjMyMDMgMTYuODkgOS40MjAzMSAxNS45OSA4LjMyMDMxIDE1Ljk5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NightsStay = createIcon('NightsStay', [
  [
    'path',
    {
      d: 'M12.4203 12.07C10.0903 7.56 11.9203 3.59 12.9503 2C7.59031 2.19 3.30031 6.58 3.30031 11.99C3.30031 12.13 3.32031 12.27 3.32031 12.41C3.94031 12.14 4.61031 11.99 5.32031 11.99C6.98031 11.99 8.50031 12.82 9.42031 14.14C11.0903 14.62 12.3203 16.16 12.3203 17.99C12.3203 19.51 11.4503 20.82 10.2003 21.5C11.1803 21.82 12.2303 22 13.3103 22C16.8103 22 19.8903 20.2 21.6803 17.48C19.3203 17.71 14.7003 16.51 12.4203 12.07Z',
      key: '7m2u0b',
    },
  ],
  [
    'path',
    {
      d: 'M8.32031 15.99H8.14031C7.72031 14.83 6.62031 13.99 5.32031 13.99C3.66031 13.99 2.32031 15.33 2.32031 16.99C2.32031 18.65 3.66031 19.99 5.32031 19.99H8.32031C9.42031 19.99 10.3203 19.09 10.3203 17.99C10.3203 16.89 9.42031 15.99 8.32031 15.99Z',
      key: '1472p9',
    },
  ],
]);

export default NightsStay;
